import { appTheme } from '../../themes/theme';

/** STATUS  **/
export const STATUS_NEW_ENTRY = 0;
export const STATUS_IN_TRANSIT_TO_WAREHOUSE = 1;
export const STATUS_AT_WAREHOUSE = 2;
export const STATUS_SCHEDULED_FOR_LOADING = 3;
export const STATUS_LOADED = 4;
export const STATUS_DELIVERED_TO_TRANSIT_WAREHOUSE = 5;
export const STATUS_LOADED_FROM_TRANSIT_WAREHOUSE = 6;
export const STATUS_DELIVERED = 7;
export const STATUS_NEW_ENTRY_NOT_CONFIRMED = 998;
export const STATUS_DELETED = 999;

type vehicleStatusMapType = {
  [key: string]: string;
};

export const VEHICLE_STATUS_LABEL_MAP: vehicleStatusMapType = {
  [STATUS_NEW_ENTRY_NOT_CONFIRMED]: 'New entry - not confirmed',
  [STATUS_NEW_ENTRY]: 'New entry',
  [STATUS_IN_TRANSIT_TO_WAREHOUSE]: 'In transit to warehouse',
  [STATUS_AT_WAREHOUSE]: 'At warehouse',
  [STATUS_SCHEDULED_FOR_LOADING]: 'Scheduled for loading',
  [STATUS_LOADED]: 'Loaded',
  [STATUS_DELIVERED_TO_TRANSIT_WAREHOUSE]: 'Delivered to transit warehouse',
  [STATUS_LOADED_FROM_TRANSIT_WAREHOUSE]: 'Loaded from transit warehouse',
  [STATUS_DELIVERED]: 'Delivered',
  [STATUS_DELETED]: 'Deleted',
};

export const VEHICLE_STATUS_COLOR_MAP: vehicleStatusMapType = {
  [STATUS_NEW_ENTRY_NOT_CONFIRMED]: '#ca9a33',
  [STATUS_NEW_ENTRY]: '#c0ca33',
  [STATUS_IN_TRANSIT_TO_WAREHOUSE]: '#1e88e5',
  [STATUS_AT_WAREHOUSE]: '#1e88e5',
  [STATUS_SCHEDULED_FOR_LOADING]: '#ffb300',
  [STATUS_LOADED]: '#ffb300',
  [STATUS_DELIVERED_TO_TRANSIT_WAREHOUSE]: '#273377',
  [STATUS_LOADED_FROM_TRANSIT_WAREHOUSE]: '#273377',
  [STATUS_DELIVERED]: '#c5cae9',
  [STATUS_DELETED]: '#e53935',
};

export const VEHICLE_STATUS_COMPLETION_PERCENTAGE_MAP: vehicleStatusMapType = {
  [STATUS_NEW_ENTRY_NOT_CONFIRMED]: '1%',
  [STATUS_NEW_ENTRY]: '5%',
  [STATUS_IN_TRANSIT_TO_WAREHOUSE]: '10%',
  [STATUS_AT_WAREHOUSE]: '20%',
  [STATUS_SCHEDULED_FOR_LOADING]: '30%',
  [STATUS_LOADED]: '40%',
  [STATUS_DELIVERED_TO_TRANSIT_WAREHOUSE]: '60%',
  [STATUS_LOADED_FROM_TRANSIT_WAREHOUSE]: '80%',
  [STATUS_DELIVERED]: '100%',
  [STATUS_DELETED]: '100%',
};

/** MECHANICAL STATUS **/
export const MECHANICAL_STATUS_UNKNOWN = 0;
export const MECHANICAL_STATUS_KEYS = 1;
export const MECHANICAL_STATUS_RUN_AND_DRIVE = 2;
export const MECHANICAL_STATUS_STARTS = 3;
export const MECHANICAL_STATUS_DOES_NOT_START = 4;

export const MECHANICAL_STATUS_LABEL_MAP: vehicleStatusMapType = {
  [MECHANICAL_STATUS_UNKNOWN]: 'Unknown',
  [MECHANICAL_STATUS_KEYS]: 'Keys',
  [MECHANICAL_STATUS_RUN_AND_DRIVE]: 'Run and drive',
  [MECHANICAL_STATUS_STARTS]: 'Starts',
  [MECHANICAL_STATUS_DOES_NOT_START]: 'Does not start',
};

export const MECHANICAL_STATUS_LABEL_COLOR_MAP: vehicleStatusMapType = {
  [MECHANICAL_STATUS_UNKNOWN]: appTheme.palette.primary.main,
  [MECHANICAL_STATUS_KEYS]: 'inherit',
  [MECHANICAL_STATUS_RUN_AND_DRIVE]: 'inherit',
  [MECHANICAL_STATUS_STARTS]: 'inherit',
  [MECHANICAL_STATUS_DOES_NOT_START]: 'inherit',
};

/** FUEL TYPE  **/
export const FUEL_TYPE_GAS = 'Gasoline';
export const FUEL_TYPE_DIESEL = 'Diesel';
export const FUEL_TYPE_ELECTRIC = 'Electric';
export const FUEL_TYPE_HYBRID = 'Gasoline Electric';

export const VEHICLE_FUEL_TYPE_COLOR_MAP: vehicleStatusMapType = {
  [FUEL_TYPE_GAS]: '#1a237e',
  [FUEL_TYPE_DIESEL]: '#a02725',
  [FUEL_TYPE_ELECTRIC]: '#43a047',
  [FUEL_TYPE_HYBRID]: '#1e88e5',
};

/** WAREHOUSE_DELIVERY **/
export const WAREHOUSE_DELIVERY_SELF = 0;
export const WAREHOUSE_DELIVERY_DISPATCH = 1;

export const WAREHOUSE_DELIVERY_LABEL_MAP: vehicleStatusMapType = {
  [WAREHOUSE_DELIVERY_SELF]: 'Self',
  [WAREHOUSE_DELIVERY_DISPATCH]: 'Dispatch',
};

export const SHIPPING_LINE_MSC = 'MSC';
export const SHIPPING_LINE_MAERSK = 'MAERSK';
export const SHIPPING_LINE_OOCL = 'OOCL';
export const SHIPPING_LINE_HAPAG_LLOYD = 'HAPAG-LLOYD';

export const SHIPPING_LINE_TRACKING_LINK_MAP: vehicleStatusMapType = {
  [SHIPPING_LINE_MSC]: 'https://www.msc.com/en/track-a-shipment',
  [SHIPPING_LINE_MAERSK]: 'https://www.maersk.com/tracking/',
  [SHIPPING_LINE_OOCL]: 'https://www.oocl.com/eng/ourservices/eservices/cargotracking/pages/cargotracking.aspx',
  [SHIPPING_LINE_HAPAG_LLOYD]: 'https://www.hapag-lloyd.com/en/online-business/track/track-by-container-solution.html',
};

export const getShippingLineTrackingLink = (shippingLine: string) => {
  if (shippingLine in SHIPPING_LINE_TRACKING_LINK_MAP) {
    return SHIPPING_LINE_TRACKING_LINK_MAP[shippingLine];
  }
  return '';
};

/** VEHICLE FILE TYPE **/
export const FILE_TYPE_PICTURE = 'picture';
export const FILE_TYPE_GATE_PASS = 'gate_pass';
export const FILE_TYPE_BILL_OF_SALE = 'bill_of_sale';
export const FILE_TYPE_POA = 'poa';
export const FILE_TYPE_INVOICE = 'invoice';
export const FILE_TYPE_TITLE = 'title';
export const FILE_TYPE_OTHER = 'other';
